// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1HFgu","header":"Messages_header__Knx84"};